module.exports = __webpack_public_path__ + "ubuntu-e685b8b37c27ef4f9125532ca9fbb450.svg";